import { common } from './common'
import { shell } from './shell'
import { pos } from './pos'
import { shift } from './shift'
import { lib } from './lib'
import { credit } from './credit'
import { kiosk } from './kiosk'
import { warehouse } from './warehouse'
import { accounting } from './accounting'
import { suppliers } from './suppliers'
import { staff } from './staff'
import { settings } from './settings'
import { guide } from './guide'
import { auth } from './auth'
import { templates } from './templates'
import { landing } from './landing'
import { orders } from './orders'
import { site } from './site'
import { club } from './club'
import { need } from './need'
import { tables } from './tables'
import { waiter } from './waiter'
import { kitchen } from './kitchen'

/** Georgian — the source language: every key the app may ask for is here. */
export const ka = { ...common, ...shell, ...pos, ...shift, ...lib, ...credit, ...kiosk, ...warehouse, ...accounting, ...suppliers, ...staff, ...settings, ...guide, ...auth, ...templates, ...landing, ...orders, ...site, ...club, ...need, ...tables, ...waiter, ...kitchen } as const

export { common, shell, pos, shift, lib, credit, kiosk, warehouse, accounting, suppliers, staff, settings, guide, auth, templates, landing, orders, site, club, need, tables, waiter, kitchen }
